<template>
  <el-dialog :visible.sync="dialogVisible" width="60%">
    <div slot="title">
      <div class="notice-subject">{{ noticeInfo.noticeTitle }}</div>
      <div class="notice-date">{{ noticeInfo.startDate | parseTime('{y}-{m}-{d}') }}</div>
    </div>
    <div class="notice-content" v-html="convertText2Html(noticeInfo.noticeContent)"></div>
    <span slot="footer">
      <el-button class="btn-red" @click="dialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { commonUtils } from '@/utils/common'
export default {
  name: 'notice-content',
  data () {
    return {
      dialogVisible: false,
      noticeInfo: {
        noticeId: '',
        noticeTitle: '',
        noticeContent: '',
        startDate: null
      }
    }
  },
  methods: {
    convertText2Html: commonUtils.convertText2Html,
    show (notice) {
      this.noticeInfo = Object.assign(this.noticeInfo, notice)
      this.dialogVisible = true
    },
    resetData () {
      this.noticeInfo = {
        noticeId: '',
        noticeTitle: '',
        noticeContent: '',
        startDate: null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-subject {
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
}
.notice-date {
  color: $base-grey;
  padding-top: 10px;
}
.notice-content {
  min-height: 360px;
  line-height: 24px;
}
</style>
